module.exports = __webpack_public_path__ + "img/icon-checkout-5.a9edf737.svg";